<template>
  <div class="detail">
    <div class="back-btn" @click="$router.back()">← 返回</div>
    
    <div class="header">
      <div class="number">{{ product.dollNumber }}</div>
      <h1 class="name">{{ product.name }}</h1>
    </div>
    
    <div class="image-section">
      <div v-if="currentImage" class="main-image-container">
        <img 
          :src="currentImage" 
          alt=""
          class="main-image"
        />
      </div>
      <div v-else class="main-image-placeholder">
        <span>暂无图片</span>
      </div>
      <div v-if="displayImages.length > 1" class="thumbnails">
        <div 
          v-for="(img, i) in displayImages" 
          :key="i" 
          class="thumbnail"
          :class="{ active: i === currentIndex }"
          @click="currentIndex = i"
        >
          <img :src="img" alt="" />
        </div>
      </div>
    </div>
    
    <div class="section">
      <h2 class="section-title">设计亮点</h2>
      <p class="highlights">{{ product.highlights || '暂无描述' }}</p>
    </div>
    
    <div v-if="product.accessories && product.accessories.length" class="section">
      <h2 class="section-title">配件展示</h2>
      <div class="accessories-scroll">
        <div
          v-for="(acc, i) in product.accessories"
          :key="i"
          class="accessory-item"
        >
          <img :src="acc" alt="配件" />
        </div>
      </div>
    </div>
    
    <!-- 点赞区域 -->
    <div class="love-section">
      <div class="love-area" @click="handleLove">
        <!-- 浮动爱心动画 -->
        <div
          v-for="heart in floatingHearts"
          :key="heart.id"
          class="float-heart"
          :style="heart.style"
        >
          ❤️
        </div>
        <!-- 爱心按钮 -->
        <div class="love-icon" :class="{ active: loved }">
          <svg viewBox="0 0 24 24" width="32" height="32" fill="currentColor">
            <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/>
          </svg>
        </div>
        <span class="love-count">{{ displayLoves }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { productApi } from '../api';

export default {
  name: 'Detail',
  data() {
    return {
      product: {},
      loved: false,
      loveCount: 0,
      currentIndex: 0,
      floatingHearts: [],
      heartId: 0
    };
  },
  computed: {
    displayImages() {
      if (this.product.images && this.product.images.length) {
        return this.product.images;
      }
      return [this.product.coverImage];
    },
    currentImage() {
      return this.displayImages[this.currentIndex] || this.product.coverImage;
    },
    displayLoves() {
      return this.loveCount > 999 ? '999+' : this.loveCount;
    }
  },
  mounted() {
    this.loadDetail();
  },
  methods: {
    async loadDetail() {
      try {
        const res = await productApi.getDetail(this.$route.params.id);
        if (res.data.code === 200) {
          this.product = res.data.data;
        }
      } catch (e) {
        console.error(e);
      }
    },
    handleLove() {
      if (!this.loved) {
        this.loveCount++;
        this.spawnHeart();
      }
      this.loved = !this.loved;
    },
    spawnHeart() {
      const id = ++this.heartId;
      const x = 20 + Math.random() * 40; // 随机水平偏移
      const heart = {
        id,
        style: {
          left: `${x}%`,
          animationDuration: `${1 + Math.random() * 0.5}s`,
          fontSize: `${18 + Math.random() * 14}px`
        }
      };
      this.floatingHearts.push(heart);
      // 动画结束后移除
      setTimeout(() => {
        this.floatingHearts = this.floatingHearts.filter(h => h.id !== id);
      }, 1500);
    }
  }
};
</script>

<style scoped>
.detail {
  padding: 16px 16px 100px;
  background-color: #F9F7F5;
  min-height: 100vh;
}

.back-btn {
  padding: 8px 0;
  margin-bottom: 16px;
  color: #666;
  cursor: pointer;
  font-size: 15px;
}

.header {
  margin-bottom: 24px;
}

.number {
  color: #999;
  font-size: 14px;
  margin-bottom: 8px;
  letter-spacing: 1px;
}

.name {
  font-size: 28px;
  color: #2c2c2c;
  font-family: 'Georgia', 'Noto Serif SC', serif;
  font-weight: 600;
  line-height: 1.3;
}

.image-section {
  margin-bottom: 32px;
  border-radius: 16px;
  overflow: hidden;
  background: #fff;
  box-shadow: 0 2px 12px rgba(0,0,0,0.06);
}

.main-image-container {
  width: 100%;
  height: 400px;
}

.main-image {
  width: 100%;
  height: 400px;
  object-fit: cover;
}

.main-image-placeholder {
  width: 100%;
  height: 400px;
  background: #f0f0f0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999;
  font-size: 18px;
}

.thumbnails {
  display: flex;
  gap: 8px;
  padding: 12px;
  overflow-x: auto;
}

.thumbnail {
  flex-shrink: 0;
  width: 60px;
  height: 60px;
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  border: 2px solid transparent;
  transition: border-color 0.2s;
}

.thumbnail.active {
  border-color: #A8E6CF;
}

.thumbnail img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.section {
  margin-bottom: 32px;
}

.section-title {
  font-size: 18px;
  color: #2c2c2c;
  margin-bottom: 12px;
  padding-bottom: 8px;
  border-bottom: 1px solid #e8e4e0;
  font-family: 'Georgia', 'Noto Serif SC', serif;
  letter-spacing: 2px;
}

.highlights {
  color: #666;
  line-height: 1.8;
  font-size: 15px;
}

.accessories-scroll {
  display: flex;
  gap: 12px;
  overflow-x: auto;
  padding-bottom: 8px;
}

.accessory-item {
  flex-shrink: 0;
}

.accessory-item img {
  width: 100px;
  height: 100px;
  object-fit: cover;
  border-radius: 12px;
}

/* 点赞区域 */
.love-section {
  padding: 20px 0 40px;
  display: flex;
  justify-content: center;
}

.love-area {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
}

.love-icon {
  width: 56px;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 4px 20px rgba(0,0,0,0.08);
  color: #ccc;
  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

.love-icon.active {
  color: #ff4757;
  transform: scale(1.15);
  box-shadow: 0 6px 24px rgba(255, 71, 87, 0.25);
}

.love-count {
  font-size: 14px;
  color: #999;
  font-weight: 500;
}

/* 浮动爱心动画 - 抖音直播风格 */
.float-heart {
  position: absolute;
  bottom: 60px;
  pointer-events: none;
  animation: floatUp 1.5s ease-out forwards;
  z-index: 10;
  filter: drop-shadow(0 2px 4px rgba(255,71,87,0.3));
}

@keyframes floatUp {
  0% {
    opacity: 1;
    transform: translateY(0) scale(0.5) rotate(-10deg);
  }
  25% {
    opacity: 1;
    transform: translateY(-30px) scale(1.2) rotate(5deg);
  }
  50% {
    opacity: 0.8;
    transform: translateY(-60px) scale(1) rotate(-3deg);
  }
  75% {
    opacity: 0.4;
    transform: translateY(-90px) scale(0.8) rotate(8deg);
  }
  100% {
    opacity: 0;
    transform: translateY(-120px) scale(0.4) rotate(0deg);
  }
}
</style>
